import { API_ENDPOINTS } from '@tsgecart/config';
import { storefrontApiFetch } from '../../../../lib/api/storefront-client.js';
import type { RewardCouponDto, SpinHistoryDto, SpinResult, SpinStatus } from '../types/rewards.js';

export interface FetchOptions {
  token: string;
  signal?: AbortSignal;
}

export async function fetchSpinStatus(options: FetchOptions): Promise<SpinStatus> {
  return storefrontApiFetch<SpinStatus>(`${API_ENDPOINTS.rewards}/spin/status`, options);
}

export async function spin(options: FetchOptions): Promise<SpinResult> {
  return storefrontApiFetch<SpinResult>(`${API_ENDPOINTS.rewards}/spin`, { ...options, method: 'POST' });
}

export async function fetchSpinHistory(
  params: { limit?: number; offset?: number },
  options: FetchOptions,
): Promise<SpinHistoryDto[]> {
  const query = new URLSearchParams();
  if (params.limit !== undefined) query.set('limit', String(params.limit));
  if (params.offset !== undefined) query.set('offset', String(params.offset));
  const suffix = query.toString() ? `?${query.toString()}` : '';
  return storefrontApiFetch<SpinHistoryDto[]>(`${API_ENDPOINTS.rewards}/history${suffix}`, options);
}

export async function fetchRewardCoupons(
  params: { onlyAvailable: boolean },
  options: FetchOptions,
): Promise<RewardCouponDto[]> {
  const query = new URLSearchParams({ onlyAvailable: String(params.onlyAvailable) });
  return storefrontApiFetch<RewardCouponDto[]>(`${API_ENDPOINTS.rewards}/coupons?${query.toString()}`, options);
}
